module.exports = __webpack_public_path__ + "static/media/icon_jishuzhicheng.4f3a99c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/icon_jishuzhicheng.svg
// module id = 75
// module chunks = 0